import { Link, NavLink } from "react-router-dom";
import styled from "styled-components";
import anniversaryLogo from "../../assets/aniversario/logo-20-anos.png";
import { useState } from "react";
import { mobileWidth } from "../../style";


function App() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const path = window.location.pathname;
    return (
        <NavStyled>
            <Logo />
            <HamburgerNav>
                <div className="burger">
                    <button
                        type="button"
                        aria-label={isMenuOpen ? "Cerrar menú" : "Abrir menú"}
                        aria-expanded={isMenuOpen}
                        onClick={() => setIsMenuOpen(!isMenuOpen)}
                    >
                        <span aria-hidden="true">{isMenuOpen ? '×' : '☰'}</span>
                    </button>
                </div>
                {isMenuOpen &&
                    <MobileLinksStyled aria-label="Navegación principal" onClick={() => setIsMenuOpen(false)}>
                        <LinkStyled id="top14" style={{ marginTop: 30 }} to="/sala" path={path.includes("sala")}>Sala</LinkStyled>
                        <HrStyled></HrStyled>
                        <LinkStyled to="/sala/alquiler" path={path.includes("alquiler")}>Alquiler</LinkStyled>
                        <LinkStyled to="/sala/programacion" path={path.includes("programacion")}>Programacion</LinkStyled>
                        <LinkStyled id="top14" style={{ marginTop: 20 }} to="/escuela" path={path.includes("escuela")}>Escuela</LinkStyled>
                        <HrStyled></HrStyled>
                        <LinkStyled to="/escuela/talleres" path={path.includes("talleres")}>Talleres</LinkStyled>
                        <LinkStyled to="/escuela/cursos" path={path.includes("cursos")}>Cursos</LinkStyled>
                        <LinkStyled to="/escuela/equipo" path={path.includes("equipo")}>Equipo</LinkStyled>
                    </MobileLinksStyled>}
            </HamburgerNav>
            <Right>
                <LinksCointainer>
                    <LinkStyled id="top14" to="/sala" path={path.includes("sala")}>Sala </LinkStyled>
                    |
                    <LinkStyled id="top14" to="/escuela" path={path.includes("escuela")}>Escuela</LinkStyled>
                </LinksCointainer>
                <HrStyled />
                {path.includes("sala") ? <SalaNav path={path} /> : <EscuelaNav path={path} />}
            </Right>
        </NavStyled>
    );
}

function SalaNav({ path }) {
    return (
        <LinksCointainer>
            <LinkStyled to="/sala/alquiler" path={path.includes("alquiler")}>Alquiler</LinkStyled>
            |
            <LinkStyled to="/sala/programacion" path={path.includes("programacion")}>Programacion</LinkStyled>
        </LinksCointainer>
    )
}

function EscuelaNav({ path }) {
    return (
        <LinksCointainer>
            <LinkStyled to="/escuela/talleres" path={path.includes("talleres")}>Talleres</LinkStyled>
            |
            <LinkStyled to="/escuela/cursos" path={path.includes("cursos")}>Cursos</LinkStyled>
            |
            <LinkStyled to="/escuela/equipo" path={path.includes("equipo")}>Equipo</LinkStyled>
        </LinksCointainer>
    )
}

export function Logo({ home = false }) {
    return (
        <LogoStyled to="/" $home={home} aria-label="La Usina — Inicio">
            <LogoImage
                src={anniversaryLogo}
                width="1006"
                height="222"
                alt="La Usina. Espacio de formación, creación e investigación teatral. 20 años haciendo teatro."
            />
        </LogoStyled>
    )
}

export default App;

const HamburgerNav = styled.div`
    display: none;
    @media (max-width: ${mobileWidth}) {
        display: flex;
        flex-shrink: 0;
        align-items: flex-end;
        background-color: white;
        font-size: 1.5rem;

        button {
            display: grid;
            place-items: center;
            min-width: 44px;
            min-height: 44px;
            padding: 0.25rem;
            color: #171717;
            font-size: 2rem;
            background-color: white;
            border: none;
            &:hover {
                cursor: pointer;
            }
            &:focus-visible {
                outline: 3px solid #171717;
                outline-offset: 2px;
            }
        }
    }
`;

const MobileLinksStyled = styled.nav`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 0.75rem;
    position: absolute;
    top: 100%;
    right: 0;
    max-width: 100%;
    max-height: calc(100svh - 100%);
    overflow-y: auto;
    padding: 1rem;
    background: white;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);

    a {
        overflow-wrap: anywhere;
        max-width: 100%;
    }
`;

const LinkStyled = styled(NavLink)`
    font-family: 'Neuropol';
    color: ${p => p.path ? "#f46d2b" : "black"};
    letter-spacing: 0.2rem;
    margin-inline: 1rem;
    text-decoration: none;
    
    :hover{
        color: #f46d2b;
    }
    :active {
        color: #f46d2b;
    }

    &:focus-visible {
        outline: 3px solid #171717;
        outline-offset: 3px;
    }

`
const LinksCointainer = styled.div`
    display:flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    font-family: 'Roboto', sans-serif;
`

const NavStyled = styled.header`

    flex-grow: 1;
    display:flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
    font-size: clamp(1.25rem, 2.2vw, 2rem);
    font-family: 'Neuropol';
    min-height: 8rem;
    gap: 1.5rem;
    padding: 1rem;
    margin-bottom: 5rem;
    width: 100%;
    position: -webkit-sticky; /* Safari */
    position: sticky;
    top: 0; /* distance from the top */
    background-color: white;
    z-index: 999999;

    @media (max-width: ${mobileWidth}) {
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        flex-wrap: nowrap;
        gap: 1rem;
        min-height: 6rem;
        margin-bottom: 8rem;
        font-size: 1.2rem;
    }

    #top14 {
        font-size: clamp(1.75rem, 2.8vw, 2.5rem);
        @media (max-width: ${mobileWidth}) {
            font-size: 2rem;
        }
    }
`

const LogoStyled = styled(Link)`
    display: block;
    flex: ${p => p.$home ? '0 1 auto' : '0 1 32rem'};
    width: ${p => p.$home ? 'min(100%, 40rem)' : '40%'};
    min-width: 0;

    &:focus-visible {
        outline: 3px solid #171717;
        outline-offset: 5px;
    }

    @media (max-width: ${mobileWidth}) {
        width: ${p => p.$home ? 'min(100%, 40rem)' : 'calc(100% - 60px)'};
    }
`;

const LogoImage = styled.img`
    display: block;
    width: 100%;
    height: auto;
`;

const Right = styled.div`
    display:flex;
    flex: 1 0 auto;
    min-width: 0;
    align-items: flex-end;
    justify-content: center;
    flex-direction: column;
    @media (max-width: ${mobileWidth}) {
        display: none;
    }
`

export const HrStyled = styled.hr`
    border: solid #f46d2b;
    width: 100%;
    padding: 0;
    margin: 0;
    box-sizing: border-box; 
    overflow: hidden;
`
